import React from "react";
import styled from "styled-components";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
const Loading = styled.div `
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LoadingButton = ({ isLoading, children, onClick, disabled = false, className, "data-testid": testId, variant = "contained", size = "medium", color = "primary", type = "submit", fullWidth, style, }) => {
    let muiVariant = variant == "primary" ? "contained" : variant;
    return (React.createElement(Button, { className: className, onClick: onClick, variant: muiVariant, disabled: isLoading || disabled, size: size, color: color, type: type, "data-testid": testId, fullWidth: fullWidth, style: style },
        children,
        isLoading && (React.createElement(Loading, null,
            React.createElement(CircularProgress, { size: 20, color: "secondary" })))));
};
export default LoadingButton;
